import $ from 'jquery';
import {MediaQuery} from 'foundation-sites/js/foundation.util.mediaQuery.js'

export default class ShowroomPageView {
    constructor(params) {
        this.params = params;
    }

    init() {
        import('flexslider').then(() => {
            $(document).ready(() => {
                this.setupSelectors();
                this.setupEvents();
                this.carousel();
                this.switchElements();
                this.checkUrl();
            });
        });
    }

    setupSelectors() {
        this.$storeLocator = $('#store-locator');
        this.$locationInput = $('#location-input');
        this.$locationSubmit = $('#location-submit');
        this.$positionButton = $('#position-button');
        this.$showAllButton = $('#show-all');
        this.$description = $('#description');
        this.$storeInfo = $('#store-info');
        this.carouselRanges = $('#carouselRanges');
        this.carouselSofas = $('#carouselSofas');
        this.carouselReviews = $('#carouselReviews');
    }

    setupEvents() {
        let me = this;

        me.$storeLocator.removeClass('hidden');

        $(window).on('changed.zf.mediaquery', function () {
            me.switchElements();
        });

        me.$locationInput.on('click', function (e) {
            e.preventDefault();
            me.importPageAction('locationForm');
        });

        me.$locationSubmit.on('click', function (e) {
            e.preventDefault();
            me.importPageAction('locationForm');
        });

        me.$positionButton.on('click', function (e) {
            e.preventDefault();
            me.importPageAction('positionButton');
        });

        me.$showAllButton.on('click', function (e) {
            e.preventDefault();
            me.importPageAction('showAll');
        });
    }

    switchElements() {
        if (MediaQuery.atLeast('medium')) {
            this.$description.insertAfter("#title");
            this.$storeInfo.insertAfter("#address");
        } else {
            this.$description.insertAfter("#map");
            this.$storeInfo.insertAfter("#carousels");
        }
    }

    carousel() {
        let me = this;
        let next = '<i class="fas fa-chevron-right"></i>';
        let prev = '<i class="fas fa-chevron-left"></i>';

        let sliderParrams = {
            animation: "slide",
            controlNav: false,
            slideshow: false,
            itemWidth: 212,
            itemMargin: 10,
            maxItems: me.getGridSize(),
            minItems: me.getGridSize(),
            prevText: prev,
            nextText: next
        }

        let sliderParramsReviews = {
            animation: "slide",
            controlNav: false,
            slideshow: false,
            itemWidth: 120,
            itemMargin: 20,
            maxItems: me.getGridSize('reviews'),
            minItems: me.getGridSize('reviews'),
            prevText: prev,
            nextText: next,
            start: function (slider) {
                me.animateHeightOfReviews(slider);
            },
            after: function (slider) {
                me.animateHeightOfReviews(slider);
            }
        }

        me.carouselRanges.flexslider(sliderParrams);
        me.carouselSofas.flexslider(sliderParrams);
        me.carouselReviews.flexslider(sliderParramsReviews);

        window.onresize = function () {
            if (me.carouselRanges.length) {
                me.carouselRanges.data('flexslider').vars.minItems = me.getGridSize();
                me.carouselRanges.data('flexslider').vars.maxItems = me.getGridSize();
            }
            if (me.carouselSofas.length) {
                me.carouselSofas.data('flexslider').vars.minItems = me.getGridSize();
                me.carouselSofas.data('flexslider').vars.maxItems = me.getGridSize();
            }
            if (me.carouselReviews.length) {
                me.carouselReviews.data('flexslider').vars.minItems = me.getGridSize('reviews');
                me.carouselReviews.data('flexslider').vars.maxItems = me.getGridSize('reviews');
            }
        }
    }

    animateHeightOfReviews(slider) {
        let sliderHeight = 0;
        slider.find('.slides li').removeClass("active-slides");
        for (let i = (slider.move * (slider.currentSlide)) + 1; i <= (slider.move * (slider.currentSlide + 1)); i++) {
            $('#carouselReviews .slides li:nth-child(' + i + ')').addClass('active-slides');
        }
        slider.find('.active-slides').each(function () {
            sliderHeight = $(this).outerHeight() > sliderHeight ? $(this).outerHeight() : sliderHeight;
        });
        slider.find('.flex-viewport').animate({height: sliderHeight}, 100);
    }

    getGridSize(slider) {
        if (slider === 'reviews') {
            return (window.innerWidth < 639) ? 1 : (window.innerWidth < 900) ? 2 : 3;
        } else {
            return (window.innerWidth < 639) ? 2 : (window.innerWidth < 920) ? 3 : 4;
        }
    }

    checkUrl()
    {
        const urlParams = new URLSearchParams(window.location.search);
        const lat = urlParams.get('lat');
        const long = urlParams.get('long');
        if (lat && long) {
            this.importPageAction('fromUrl', parseFloat(lat), parseFloat(long));
            return;
        }

        const action = urlParams.get('action');
        if (action === 'showAll') {
            this.importPageAction('showAll');
        } else if (action === 'positionButton') {
            this.importPageAction('positionButton');
        }
    }

    importPageAction(action, lat, long)
    {
        import('./landing').then((Module) => {
            //remove the click event
            this.$locationInput.off('click');
            this.$locationSubmit.off('click');
            this.$positionButton.off('click');
            this.$showAllButton.off('click');

            let params = this.params;
            params.action = action;

            if (lat && long) {
                params.initialPosition = {
                    coords: {
                        latitude: lat,
                        longitude: long,
                    }
                };
            }

            let module = new Module.default(params);
            module.init();
        });
    }
}
